import React, {
  useState,
  SyntheticEvent,
  useRef,
  useLayoutEffect,
} from 'react';

import ErrorText from '../ErrorText';
import * as S from './styles';
import { FormFieldType } from 'utils/types';

export type Props = {
  name: string;
  value?: string;
  error?: string;
  placeholder?: string;
  type?: string;
  onChange: (formField: FormFieldType) => void;
  onValidate?: (formField: FormFieldType) => void;
  [key: string]: any;
};

function Input(props: Props) {
  const {
    name,
    value = '',
    error,
    placeholder,
    onChange,
    onValidate,
    type = 'text',
    shouldFocus,
    ...rest
  } = props;

  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const isEmpty = value === '';
  const hasError = !!error;
  const showPlaceholder = true; // Carried over from Results; may want to remove var?

  useLayoutEffect(() => {
    const { current } = inputRef;

    // TODO: find another solution from this setTimeout for animation mismatch timing
    if (current && shouldFocus) {
      setTimeout(() => {
        current.focus();
      }, 300);
    }
  }, [shouldFocus]);

  function handleChange(event: SyntheticEvent<HTMLInputElement>) {
    const { currentTarget } = event;
    onChange({ name: currentTarget.name, value: currentTarget.value });
  }

  function handleBlur(event: SyntheticEvent<HTMLInputElement>) {
    setIsFocused(false);

    if (onValidate) {
      const { currentTarget } = event;
      onValidate({ name: currentTarget.name, value: currentTarget.value });
    }
  }

  function handleFocus() {
    setIsFocused(true);
  }

  return (
    <>
      <S.Wrapper>
        <S.InputWrapper>
          <S.Input
            ref={inputRef}
            maxLength={80}
            {...rest}
            onChange={handleChange}
            name={name}
            value={`${value}`}
            id={name}
            placeholder={showPlaceholder ? placeholder : undefined}
            data-has-error={hasError}
            data-is-empty={isEmpty}
            data-is-focused={isFocused}
            onFocus={handleFocus}
            onBlur={handleBlur}
            type={type}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
          />
          <ErrorText>{error}</ErrorText>
        </S.InputWrapper>
        <S.PromoButton type="submit" disabled={isEmpty}>
          Apply
        </S.PromoButton>
      </S.Wrapper>
    </>
  );
}

export default Input;
